import React, {Component} from 'react'
import PropTypes from "prop-types";
import {connect} from 'react-redux'

import {Signup as SignupLayout} from '../layouts';
import Wizard from '../components/IntegrationWizard/Wizard'


class IntegrationWizard extends Component {

    goToRisks = () => {
        this.props.router.push('/risks');
    }

    render() {
        const pms = (this.props.router.asPath.split('/')[2] || '').split('?')[0];
        return (
            <SignupLayout withFooter={false}>
                <Wizard onSubmit={this.goToRisks} pms={pms} router={this.props.router} user={this.props.user}/>
            </SignupLayout>
        )
    }
}

IntegrationWizard.propTypes = {
    user: PropTypes.object.isRequired,
    authenticated: PropTypes.bool,
}

const mapStateToProps = (state) => {
    return {
        authenticated: state.auth.authenticated,
        user: state.auth.user,
    }
}

export {IntegrationWizard}
IntegrationWizard = connect(mapStateToProps, {})(IntegrationWizard)
export default IntegrationWizard
